import { ErrorState } from './chunk-MG36IFWV.js';
import * as React from 'react';
import { captureException } from '@authe/fe-commons/observability';
import { createLogger } from '@authe/fe-commons/logging';
import { isServerError } from '@authe/fe-commons/errors';
import { jsx } from 'react/jsx-runtime';

var log = createLogger("ui-core:error-boundary");
var ErrorBoundary = class extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    const context = {
      ...this.props.context,
      boundary: this.props.boundary,
      componentStack: info.componentStack ?? void 0
    };
    log.error("render error caught", context);
    captureException(error, context);
    this.props.onError?.(error, { componentStack: info.componentStack ?? "" });
  }
  componentDidUpdate(prev) {
    if (this.state.error == null) return;
    const a = prev.resetKeys;
    const b = this.props.resetKeys;
    if (a && b && (a.length !== b.length || a.some((v, i) => !Object.is(v, b[i])))) {
      this.reset();
    }
  }
  reset = () => {
    this.setState({ error: null });
  };
  render() {
    if (this.state.error != null) {
      const Fallback = this.props.fallback;
      if (Fallback) return /* @__PURE__ */ jsx(Fallback, { error: this.state.error, reset: this.reset });
      if (!isServerError(this.state.error)) {
        return /* @__PURE__ */ jsx(
          ErrorState,
          {
            error: this.state.error,
            title: "This part of the page stopped working",
            detail: "Something failed while rendering it. Earlier actions may already have been saved. Try again or reload the page, then check the current state before repeating an action.",
            onRetry: this.reset,
            alwaysAllowRetry: true
          }
        );
      }
      return /* @__PURE__ */ jsx(ErrorState, { error: this.state.error, onRetry: this.reset });
    }
    return this.props.children;
  }
};

export { ErrorBoundary };
//# sourceMappingURL=chunk-TY442XLY.js.map
//# sourceMappingURL=chunk-TY442XLY.js.map